import type { Result } from 'neverthrow';
import type { EdgeId, Graph, NodeId } from '../../../types';
import type { CommandEffect } from './effects';
import type { CommandError } from './error';

export enum CommandKind {
  AddNode = 'add_node',
  RemoveNode = 'remove_node',
  AddEdge = 'add_edge',
  RemoveEdge = 'remove_edge',
  UpdateNodeOptionValue = 'update_node_option_value',
  UpdateNodeOptionType = 'update_node_option_type',
  Composite = 'composite',
  SwapEdgeOrder = 'swap_edge_order',
}

/**
 * Dirty tags help drive partial re-evaluations an re-layout triggers.
 */
export type CommandDirty = {
  nodes: NodeId[];
  edges: EdgeId[];
  topologyChanged: boolean;
};

export type CommandResult = {
  graph: Graph;
  inverse: GraphCommand;
  effects?: CommandEffect[];
  dirty: CommandDirty;
};

export interface GraphCommand {
  readonly kind: string;

  apply(graph: Readonly<Graph>): Result<CommandResult, CommandError>;
}
